import { ROUTES } from "../../../../module/constants";

const SECTION_BASE_URL = ROUTES.ADMIN_TECHNICAL_USERS_MGMT;

export const ADMIN_TECHNICAL_USERS_MGMT_ROUTES_URL = {
  STEP_ONE: SECTION_BASE_URL,
  COUNTER: `${SECTION_BASE_URL}/counters-management`,
  RIORGANIZATION: `${SECTION_BASE_URL}/riorganization`,
};

export const STATE_IDENTIFIER = {
  LIST: "list",
  LOADER: "loader",
  ALL_COUNTERS: "allCounters",
  OU_COUNTERS: "ouCounters",
  APP_COUNTERS: "appCounters",
  COUNTER_CALL_STATE: "counterCallState",
  RIORG_IDENTITY: "riorgIdentity",
  RIORG_OUS: "riorgOus",
  RIORG_CALL_STATE: "riorgCallState",
};
